import { useCallback, useEffect, useState } from 'react'

export const useSearchTabNavigation = ({
  tabCount,
  isListeningToTabKey,
}: {
  tabCount: number
  isListeningToTabKey: boolean
}) => {
  const [currentTabIndex, setCurrentTabIndex] = useState(0)

  const handleKeyPressed = useCallback(
    (event: KeyboardEvent) => {
      const isTabKey = event.key === 'Tab'

      if (isTabKey) {
        event.preventDefault()
        event.stopPropagation()
        setCurrentTabIndex((currentTabIndex + 1) % tabCount)
      }
    },
    [currentTabIndex, tabCount],
  )

  useEffect(
    function listenToShiftKeyPressesWhenClosed() {
      if (!isListeningToTabKey) {
        return
      }

      document.addEventListener('keydown', handleKeyPressed)

      return () => {
        document.removeEventListener('keydown', handleKeyPressed)
      }
    },
    [handleKeyPressed, isListeningToTabKey],
  )

  return [currentTabIndex, setCurrentTabIndex] as const
}
